import Layout from 'HorizontalMenu/Menu'
import React from 'react'
import { Container, Navbar, Row } from 'reactstrap'
import ReportGenerationFilters from './ReportGenerationFilters'

const CompanyCustomReport = () => {
    return (
        <React.Fragment>
            <Layout>
                <Navbar />
            </Layout>
            <div className="page-content">
                <Container fluid>
                    <Row className='mb-3'>
                        <h4>Custom Report</h4>
                    </Row>
                    <ReportGenerationFilters isPopupOpen={false} />
                </Container>
            </div>
        </React.Fragment>
    )
}

export default CompanyCustomReport